




















































































import Vue from 'vue'

import ModalSimple from '@/common/components/ModalSimple.vue'
import PatternOptions from '@/groupBuy/components/requestList/PatternOptions.vue'

import {
  PrintableSku,
  PrintingOptionModel,
  PATTERN_VIEWS,
  ProductByPrintableSku
} from '@/groupBuy/types'
import { COLOR_PATTERN_TYPES, SYSTEM_ERROR } from '@/common/constants'
import service from '@/groupBuy/services'

export default Vue.extend({
  components: {
    ModalSimple,
    PatternOptions
  },
  props: {
    printableSku: {
      type: Object as () => PrintableSku,
      required: true
    },
    isFastShipping: {
      type: Boolean,
      required: true
    },
    plainGoodFastShipping: {
      type: Boolean,
      required: true
    },
    requestUuid: {
      type: String,
      required: true
    },
    sizeItems: {
      type: Array,
      required: true
    }
  },
  data(): {
    viewMode: number
    selectedColorPattern: string
    selectedEditPattern: string
    editPatterns: PrintingOptionModel[]
    psi: string
    loading: boolean
  }{
    return {
      viewMode: PATTERN_VIEWS.COLOR,
      selectedColorPattern: this.printableSku.skuColorPattern.id,
      selectedEditPattern: this.printableSku.skuEditPattern.id,
      editPatterns: [],
      psi: this.printableSku.id,
      loading: false
    }
  },
  computed: {
    modalTitle(): string {
      return this.viewMode === PATTERN_VIEWS.COLOR ? '印刷方法' : '印刷する箇所'
    },
    PATTERN_VIEWS() {
      return PATTERN_VIEWS
    },
    colorPatterns(): PrintingOptionModel[] {
      const result =   this.printableSku.sku.skuColorPatterns.map(item => {
        return {...item.colorPattern, id: item.id}
      }) as PrintingOptionModel[]
      return (this.isFastShipping && !this.plainGoodFastShipping)
        ? result.filter(item => item.type !== COLOR_PATTERN_TYPES.PLAIN)
        : result
    },
    isSelectPlain(): boolean {
      const colorPattern = this.colorPatterns.find(item => item.id === this.selectedColorPattern)
      return colorPattern?.type === COLOR_PATTERN_TYPES.PLAIN
    }
  },
  methods: {
    back() {
      this.$emit('onClose')
    },
    getPrintableSku() {
      return service.getPrintableSku({
          id: this.printableSku.sku.product.id,
          firstOptionId: this.printableSku.sku.firstSelectionOption.id,
          skuEditPatternId: this.selectedEditPattern,
          skuColorPatternId: this.selectedColorPattern
        })
    },
    async confirmColorPattern() {
      this.loading = true
      const res = await this.getPrintableSku().catch(() => {
        this.loading = false
      })
      if (res) {
        const printableSku = res.productByPrintableSku as ProductByPrintableSku
        this.editPatterns = printableSku.sku.skuEditPatterns.map(item => {
          return {...item.editPattern, id: item.id}
        })
        this.selectedEditPattern = printableSku.estimate.selectedEditPattern.id
      }
      this.loading = false
      this.viewMode = PATTERN_VIEWS.EDIT

    },
    onSelectColorPattern(id: string) {
      this.selectedColorPattern = id
    },
    onSelectEditPattern(id: string) {
      this.selectedEditPattern = id
    },
    updateRequestPsi() {
      return this.getPrintableSku().then(res => {
        if (res?.productByPrintableSku) {
          const printableSku = res.productByPrintableSku as ProductByPrintableSku
          this.psi = printableSku.printableSkuId
          return service.updateRequest(this.requestUuid, { printableSkuId: this.psi})
        }
      }).catch(() => {
        return Promise.reject(false)
      })

    },
    async addToCart() {
      this.loading = true
      await this.updateRequestPsi().catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
        this.loading = false
      })
      service.addToCart(this.requestUuid).then(() => {
        location.href = '/cart'
      })
    },
    async confirmEditPattern() {
      this.loading = true
      await this.updateRequestPsi().catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
        this.loading = false
      })
      const quantities = this.sizeItems.map(item => `${item.sizeId}-${item.quantity}`).join(',')
      const editorUrl = `/editor?psi=${this.psi}&quantities=${quantities}&group_buy_uuid=${this.requestUuid}`
      location.href = editorUrl
    }
  }
})
